import { createViewEventElement } from '@shopify/events';

/**
 * Dispatches Shopify's standard cart view event when its containing cart
 * drawer dialog opens. Shopify's analytics integrations can then translate
 * the standard event to GA4's `view_cart` event.
 */
if (!customElements.get('orynta-cart-view-event')) {
  customElements.define('orynta-cart-view-event', createViewEventElement());
}
